// extracted by mini-css-extract-plugin
module.exports = {"learnWrapper":"Learn_learnWrapper__cpG_D","learn":"Learn_learn__AvPF4"};